import { render, staticRenderFns } from "./GamanzaMissions.vue?vue&type=template&id=4ea90572&scoped=true"
import script from "./GamanzaMissions.vue?vue&type=script&lang=js"
export * from "./GamanzaMissions.vue?vue&type=script&lang=js"
import style0 from "./GamanzaMissions.vue?vue&type=style&index=0&id=4ea90572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea90572",
  null
  
)

export default component.exports